module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-dialog"
  }, [_c('el-dialog', {
    attrs: {
      "size": "tiny",
      "visible": _vm.dialogVisible
    },
    on: {
      "close": function($event) {
        _vm.dialogVisible = false
      },
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "qrcode-wrapper"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": '//qrcode.ppj.io/' + _vm.link
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v(_vm._s(_vm.$t('qrcode.project')))]), _vm._v(" "), _c('div', {
    staticClass: "link-info"
  }, [_c('el-input', {
    staticClass: "link-input",
    attrs: {
      "placeholder": _vm.$t('placeholder.project.viewer_url'),
      "readonly": ""
    },
    model: {
      value: (_vm.link),
      callback: function($$v) {
        _vm.link = $$v
      },
      expression: "link"
    }
  }, [_c('div', {
    staticClass: "append-buttons",
    slot: "append"
  }, [_c('a', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.link),
      expression: "link",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "copy el-button"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.buttons.copy')) + "\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "preview el-button",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('common.buttons.preview')) + "\n              ")])])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d71c15c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/project.dialog.vue
// module id = 913
// module chunks = 3